import { Box, MenuItem, SxProps } from "@mui/material";
import { times } from "lodash";
import { ReactNode } from "react";
import { FieldValues, UseControllerProps } from "react-hook-form";

import { RhfSelect } from "~frontend/components/forms/react-hook-form-components/RhfSelect";
import { plural } from "~frontend/util/plural";

const DEFAULT_OPTIONS = [
  ...[5, 10, 30].map(value => ({ value, label: `${value} minutes` })),
  ...times(24, i => ({
    value: (i + 1) * 60,
    label: plural(i + 1, "hour", "hours"),
  })),
];

export function RhfDurationField<T extends FieldValues>({
  name,
  label,
  bottomLabel,
  fullWidth,
  options = DEFAULT_OPTIONS,
  control,
  sx = {},
}: UseControllerProps<T> & {
  label?: string;
  bottomLabel?: string;
  fullWidth?: boolean;
  options?: { value: number; label: string }[];
  sx?: SxProps;
}): ReactNode {
  return (
    <Box sx={{ width: fullWidth ? "100%" : undefined }}>
      <RhfSelect
        sx={{ ...sx, width: fullWidth ? "100%" : undefined }}
        control={control}
        name={name}
        label={label}
        bottomLabel={bottomLabel}
      >
        {options.map(option => (
          <MenuItem key={option.value} value={option.value}>
            {option.label}
          </MenuItem>
        ))}
      </RhfSelect>
    </Box>
  );
}
